import { GlobalThemeType } from '../../themes/types';

export const BASE = 16;
export const NON_BASE_PROPS = ['opacity'];

export interface BooleanProps {
  spread: string;
  justify: string;
  align: string;
  dontShrink: string;
  full: string;
  bordered: string;
}

export const BOOLEAN_PROPS = (theme: GlobalThemeType): BooleanProps => ({
  spread: 'flex: 1 0 auto;',
  justify: 'justify-content: center;',
  align: 'align-items: center;',
  dontShrink: 'flex: 0 0 auto;',
  full: 'flex: 1;',
  bordered: `border: ${theme.outlines.border};`,
});

export const PROP_NAMES = [
  'box-shadow',
  'border',
  'border-radius',
  'color',
  'background-color',
  'background',
  'width',
  'max-width',
  'height',
  'max-height',
  'margin',
  'margin-top',
  'margin-bottom',
  'margin-left',
  'margin-right',
  'top',
  'left',
  'bottom',
  'right',
  'cursor',
  'padding',
  'padding-top',
  'padding-bottom',
  'padding-left',
  'padding-right',
  'justify-content',
  'align-items',
  'z-index',
  'align-self',
  'flex',
  'white-space',
  'overflow',
  'overflow-x',
  'overflow-y',
  'min-height',
  'opacity',
  'transform',
  'transition',
  'flex-flow',
  'flex-wrap',
  'visibility',
  'outline',
];

export const HOVER_PROP_NAMES = [
  'color',
  'background',
  'background-color',
  'opacity',
];
